"use strict";

export default class MigrationService {
    static MIGRATION_SETTINGS_ENDPOINT = '/api/migration/settings';
    static MIGRATION_JIRA_CONNECTION_ENDPOINT = '/api/migration/jira-connection';

    constructor(http, contextPath) {
        this.http = http;
        this.contextPath = contextPath;
    }

    async getSettings() {
        return await this.http.get(`${this.contextPath}${MigrationService.MIGRATION_SETTINGS_ENDPOINT}`).then((response) => response.data);
    }

    async saveSettings(settings) {
        const data = await this._saveSettingsAndGetResponse(settings);

        if (!data.success) {
            throw new Error(data.reason);
        }
    }

    async testJiraConnection(settings) {
        const data = await this._testJiraConnectionAndGetResponse(settings);

        if (!data.success) {
            throw new Error(data.reason);
        }
    }

    async _saveSettingsAndGetResponse(settings) {
        try {
            const response = await this.http.post(`${this.contextPath}${MigrationService.MIGRATION_SETTINGS_ENDPOINT}`, settings);
            return response.data;
        } catch (err) {
            const success = err?.response?.data?.success ?? false;
            const reason = err?.response?.data?.reason ?? "Unknown server error";

            return { success, reason };
        }
    }

    async _testJiraConnectionAndGetResponse(settings) {
        try {
            const response = await this.http.post(`${this.contextPath}${MigrationService.MIGRATION_JIRA_CONNECTION_ENDPOINT}`, settings);
            return response.data;
        } catch (err) {
            const success = err?.response?.data?.success ?? false;
            const reason = err?.response?.data?.reason ?? "Unknown server error";

            return { success, reason };
        }
    }
}



// WEBPACK FOOTER //
// ./src/service/migration.js